import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";
export default function useDebtHistoryDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/payment-logs/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
